import React from "react";
import PropTypes from "prop-types";
import { Eye, EyeOff } from "lucide-react";
import { getMessage } from "../data/locales";
import "./PasswordVisibilityField.css";

const PasswordVisibilityField = ({
  id,
  name,
  value,
  onChange,
  visible,
  onToggleVisible,
  showLabelKey,
  hideLabelKey,
  inputClassName,
  wrapperClassName,
  toggleClassName,
  placeholder,
  autoComplete,
  required,
  disabled,
  maxLength,
}) => {
  const showLabel = getMessage(showLabelKey);
  const hideLabel = getMessage(hideLabelKey);

  return (
    <div className={wrapperClassName}>
      <input
        id={id}
        name={name}
        type={visible ? "text" : "password"}
        className={inputClassName}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        autoComplete={autoComplete}
        required={required}
        disabled={disabled}
        maxLength={maxLength}
      />
      <button
        type="button"
        className={toggleClassName}
        onClick={onToggleVisible}
        aria-label={visible ? hideLabel : showLabel}
        aria-pressed={visible}
      >
        {visible ? <EyeOff size={18} aria-hidden="true" /> : <Eye size={18} aria-hidden="true" />}
      </button>
    </div>
  );
};

PasswordVisibilityField.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired,
  onToggleVisible: PropTypes.func.isRequired,
  showLabelKey: PropTypes.string,
  hideLabelKey: PropTypes.string,
  inputClassName: PropTypes.string,
  wrapperClassName: PropTypes.string,
  toggleClassName: PropTypes.string,
  placeholder: PropTypes.string,
  autoComplete: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  maxLength: PropTypes.number,
};

PasswordVisibilityField.defaultProps = {
  id: undefined,
  name: undefined,
  showLabelKey: "passwordVisibility.show",
  hideLabelKey: "passwordVisibility.hide",
  inputClassName: "form-control",
  wrapperClassName: "password-visibility-field",
  toggleClassName: "password-visibility-toggle",
  placeholder: undefined,
  autoComplete: undefined,
  required: false,
  disabled: false,
  maxLength: undefined,
};

export default PasswordVisibilityField;
